import { Container, Row, Col } from 'react-bootstrap';
import { SideNav } from 'Components/organisms';
import { AmpyChatSidebar, AmpyChatSidebarSide } from 'Components/organisms/AmpyChatSidebar';
import { ToastMessage } from 'Components/molecules';
import './styles.scss';

interface MainTemplateProps {
    children: React.ReactNode;
    hasBanner: boolean;
    ampyChatSide?: AmpyChatSidebarSide;
}

const MainTemplate = (props: MainTemplateProps) => {
    const ampyChatSide = props.ampyChatSide ?? 'left';
    const useSideNavToggle = ampyChatSide === 'left';

    return (
        <Container fluid className="main-template bg-structural-BG">
            <Row className="main-template__row">
                <Col lg="auto" sm="auto" xs="auto" md="auto" className="main-template__Col">
                    <SideNav showAmpyChatToggle={useSideNavToggle} />
                </Col>
                {ampyChatSide === 'left' && <AmpyChatSidebar side="left" showFloatingToggle={false} />}
                {props.hasBanner ? (
                    <Col className="main-template__table-col custom-scrollbar w-100 h-100 overflow-auto">
                        {<ToastMessage variant="error" />}
                        {props.children}
                    </Col>
                ) : (
                    <Col className="main-template__table-col custom-scrollbar w-100 h-100 overflow-auto pb-0">
                        {props.children}
                    </Col>
                )}
                {ampyChatSide === 'right' && <AmpyChatSidebar side="right" />}
            </Row>
        </Container>
    );
};

export default MainTemplate;
